import React from 'react';
import PropTypes from 'prop-types';
import { LocationIcon } from '~/modules/common/components/Icons';
import { withGroupSettings } from '~/modules/common/enhancers';
import GroupName from './GroupName';

export const LocationName = ({
  value,
  locationSettings,
  variant,
  showFullPath,
  disableIcon
}) => (
  <GroupName
    value={value}
    Icon={LocationIcon}
    groupSettings={locationSettings}
    variant={variant}
    showFullPath={showFullPath}
    disableIcon={disableIcon}
  />
);

LocationName.propTypes = {
  value: PropTypes.object,
  locationSettings: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(['icon', 'avatar']),
  showFullPath: PropTypes.bool,
  disableIcon: PropTypes.bool
};

export default withGroupSettings('location', 'locationSettings')(LocationName);
